import classNames from "classnames";
import * as React from "react";
import { ContentLoading } from "./ContentLoading";
import * as styles from "./OverlayLoading.less";

type Props = {
    isLoading: boolean;
    className?: string;
    containerRef?: React.RefObject<HTMLDivElement>;
};

export const OverlayLoading: React.FC<Props> = ({ children, isLoading, className = styles.wrapper, containerRef }) => {
    const classes = classNames(className, {
        [styles.loading]: isLoading,
    });

    return (
        <>
            <div data-testid="overlay" ref={containerRef} className={classes}>
                {children}
            </div>
            {isLoading && <ContentLoading />}
        </>
    );
};
